module.exports = __webpack_public_path__ + "img/icon-example.d4a86a4.png";